module.exports = __webpack_public_path__ + "static/img/map.6b5464c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/map.jpg
// module id = a0sQ
// module chunks = 0